export const SET_INFO_TABS = 'info_tabs/SET_INFO_TABS';

export const setInfoTabs = payload => ({
  type: SET_INFO_TABS,
  payload,
});
